(function () {
  function isPilot() {
    var vp = document.querySelector('variant-picker[data-product-handle]');
    return !!vp && vp.dataset.productHandle === 'maverick-k1';
  }
  if (!isPilot()) return;

  var PALETTE = [
    ['White', '#fcfcfc'], ['Black', '#1b1c1d'], ['Knysna Blue', '#6099a8'],
    ['Strong Blue', '#005ab8'], ['Flag Blue', '#3a366b'], ['Pool Blue', '#d7f6f6'],
    ['Protea Pink', '#d04669'], ['Signal Red', '#b73230'], ['Lime Green', '#b5d565'],
    ['Olive Green', '#657451'], ['Brillant Green', '#207c3f'], ['Loerie Green', '#77a548'],
    ['Traffic Yellow', '#f8b33c'], ['Canary Yellow', '#ffeb47'], ['Castaway Almond', '#f0e6dd'],
    ['Dark Brown', '#564445'], ['Bright Orange', '#e04a10'], ['Mid Grey', '#6d7379'],
    ['Cloud Grey', '#8e9191']
  ];
  var DEFAULT_DECK = 'Olive Green';
  var DEFAULT_COCKPIT = 'White';
  var BASE_MATCH = 'salt-maverick-k1-v7';

  var LABELS = {
    en: ['Deck Colour', 'Cockpit Colour'],
    de: ['Deckfarbe', 'Cockpitfarbe'],
    fr: ['Couleur du pont', 'Couleur du cockpit'],
    cs: ['Barva paluby', 'Barva kokpitu'],
    it: ['Colore del ponte', 'Colore del pozzetto'],
    pl: ['Kolor pokładu', 'Kolor kokpitu']
  };
  var PILL = {
    en: ['Tap to zoom and choose colour', 'Click to zoom and choose colour'],
    de: ['Zum Zoomen und Farbe wählen tippen', 'Zum Zoomen und Farbe wählen klicken'],
    fr: ['Touchez pour zoomer et choisir la couleur', 'Cliquez pour zoomer et choisir la couleur'],
    cs: ['Klepnutím přiblížíte a vyberete barvu', 'Kliknutím přiblížíte a vyberete barvu'],
    it: ['Tocca per zoomare e scegliere il colore', 'Clicca per zoomare e scegliere il colore'],
    pl: ['Dotknij, aby powiększyć i wybrać kolor', 'Kliknij, aby powiększyć i wybrać kolor']
  };
  var lg = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  var labelPair = LABELS[lg] || LABELS.en;
  var pillPair = PILL[lg] || PILL.en;
  var touch = window.matchMedia && matchMedia('(hover:none)').matches;
  var pillText = touch ? pillPair[0] : pillPair[1];

  function hexToRgb01(hex) {
    hex = hex.replace('#', '');
    return [
      parseInt(hex.slice(0, 2), 16) / 255,
      parseInt(hex.slice(2, 4), 16) / 255,
      parseInt(hex.slice(4, 6), 16) / 255
    ];
  }

  function rgbToHsv(r, g, b) {
    var max = Math.max(r, g, b), min = Math.min(r, g, b), d = max - min;
    var h = 0, s = max === 0 ? 0 : d / max, v = max;
    if (d !== 0) {
      if (max === r) h = ((g - b) / d) % 6;
      else if (max === g) h = (b - r) / d + 2;
      else h = (r - g) / d + 4;
      h /= 6;
      if (h < 0) h += 1;
    }
    return [h, s, v];
  }

  function hsvToRgb(h, s, v) {
    var i = Math.floor(h * 6), f = h * 6 - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s);
    var r, g, b;
    switch (i % 6) {
      case 0: r = v; g = t; b = p; break;
      case 1: r = q; g = v; b = p; break;
      case 2: r = p; g = v; b = t; break;
      case 3: r = p; g = q; b = v; break;
      case 4: r = t; g = p; b = v; break;
      default: r = v; g = p; b = q; break;
    }
    return [r, g, b];
  }

  function median(arr) {
    if (!arr.length) return 0.5;
    var a = Array.prototype.slice.call(arr).sort(function (x, y) { return x - y; });
    return a[Math.floor(a.length / 2)];
  }

  function labelComponents(mask, w, h) {
    var n = w * h;
    var labels = new Int32Array(n).fill(-1);
    var sizes = [];
    var queue = new Int32Array(n);
    var compId = 0;
    for (var start = 0; start < n; start++) {
      if (!mask[start] || labels[start] !== -1) continue;
      var qHead = 0, qTail = 0, size = 0;
      queue[qTail++] = start;
      labels[start] = compId;
      while (qHead < qTail) {
        var idx = queue[qHead++];
        size++;
        var x = idx % w, y = (idx / w) | 0;
        for (var dy = -1; dy <= 1; dy++) {
          var ny = y + dy;
          if (ny < 0 || ny >= h) continue;
          for (var dx = -1; dx <= 1; dx++) {
            if (dx === 0 && dy === 0) continue;
            var nx = x + dx;
            if (nx < 0 || nx >= w) continue;
            var nIdx = ny * w + nx;
            if (mask[nIdx] && labels[nIdx] === -1) {
              labels[nIdx] = compId;
              queue[qTail++] = nIdx;
            }
          }
        }
      }
      sizes.push(size);
      compId++;
    }
    return { labels: labels, sizes: sizes, count: compId };
  }

  function dilate(mask, w, h, iterations) {
    var cur = mask;
    for (var it = 0; it < iterations; it++) {
      var next = new Uint8Array(cur);
      for (var y = 0; y < h; y++) {
        for (var x = 0; x < w; x++) {
          var idx = y * w + x;
          if (cur[idx]) continue;
          var found = false;
          for (var dy = -1; dy <= 1 && !found; dy++) {
            var ny = y + dy;
            if (ny < 0 || ny >= h) continue;
            for (var dx = -1; dx <= 1; dx++) {
              if (dx === 0 && dy === 0) continue;
              var nx = x + dx;
              if (nx < 0 || nx >= w) continue;
              if (cur[ny * w + nx]) { found = true; break; }
            }
          }
          if (found) next[idx] = 1;
        }
      }
      cur = next;
    }
    return cur;
  }

  function floodFillOutside(wall, w, h) {
    var n = w * h;
    var reached = new Uint8Array(n);
    var queue = new Int32Array(n);
    var qTail = 0;
    function tryPush(idx) {
      if (!wall[idx] && !reached[idx]) { reached[idx] = 1; queue[qTail++] = idx; }
    }
    for (var x = 0; x < w; x++) { tryPush(x); tryPush((h - 1) * w + x); }
    for (var y = 0; y < h; y++) { tryPush(y * w); tryPush(y * w + (w - 1)); }
    var qHead = 0;
    while (qHead < qTail) {
      var idx = queue[qHead++];
      var x = idx % w, y = (idx / w) | 0;
      if (x > 0) tryPush(idx - 1);
      if (x < w - 1) tryPush(idx + 1);
      if (y > 0) tryPush(idx - w);
      if (y < h - 1) tryPush(idx + w);
    }
    return reached;
  }

  function boxBlur(src, w, h, radius) {
    var tmp = new Float32Array(w * h);
    var dst = new Float32Array(w * h);
    var size = radius * 2 + 1;
    for (var y = 0; y < h; y++) {
      var rowBase = y * w;
      for (var x = 0; x < w; x++) {
        var sum = 0;
        for (var dx = -radius; dx <= radius; dx++) {
          var xx = x + dx;
          if (xx < 0) xx = 0; else if (xx >= w) xx = w - 1;
          sum += src[rowBase + xx];
        }
        tmp[rowBase + x] = sum / size;
      }
    }
    for (var x2 = 0; x2 < w; x2++) {
      for (var y2 = 0; y2 < h; y2++) {
        var sum2 = 0;
        for (var dy = -radius; dy <= radius; dy++) {
          var yy = y2 + dy;
          if (yy < 0) yy = 0; else if (yy >= h) yy = h - 1;
          sum2 += tmp[yy * w + x2];
        }
        dst[y2 * w + x2] = sum2 / size;
      }
    }
    return dst;
  }

  function featherWeights(mask, w, h) {
    var f = new Float32Array(mask.length);
    for (var i = 0; i < mask.length; i++) f[i] = mask[i];
    f = boxBlur(f, w, h, 1);
    f = boxBlur(f, w, h, 1);
    f = boxBlur(f, w, h, 1);
    return f;
  }

  function majorityFilter(mask, w, h, win) {
    var r = (win - 1) >> 1;
    var half = (win * win) / 2;
    var out = new Uint8Array(mask.length);
    for (var y = 0; y < h; y++) {
      for (var x = 0; x < w; x++) {
        var count = 0;
        for (var dy = -r; dy <= r; dy++) {
          var yy = y + dy;
          if (yy < 0) yy = 0; else if (yy >= h) yy = h - 1;
          var rowBase = yy * w;
          for (var dx = -r; dx <= r; dx++) {
            var xx = x + dx;
            if (xx < 0) xx = 0; else if (xx >= w) xx = w - 1;
            count += mask[rowBase + xx];
          }
        }
        if (count > half) out[y * w + x] = 1;
      }
    }
    return out;
  }

  function chebyshevDistanceTo(mask, w, h) {
    var n = w * h;
    var dist = new Int32Array(n).fill(-1);
    var queue = new Int32Array(n);
    var qHead = 0, qTail = 0;
    for (var i = 0; i < n; i++) {
      if (mask[i]) { dist[i] = 0; queue[qTail++] = i; }
    }
    while (qHead < qTail) {
      var idx = queue[qHead++];
      var d = dist[idx];
      var x = idx % w, y = (idx / w) | 0;
      for (var dy = -1; dy <= 1; dy++) {
        var ny = y + dy;
        if (ny < 0 || ny >= h) continue;
        for (var dx = -1; dx <= 1; dx++) {
          if (dx === 0 && dy === 0) continue;
          var nx = x + dx;
          if (nx < 0 || nx >= w) continue;
          var nIdx = ny * w + nx;
          if (dist[nIdx] === -1) { dist[nIdx] = d + 1; queue[qTail++] = nIdx; }
        }
      }
    }
    return dist;
  }

  var engine = null;
  var engineReadyCbs = [];

  function buildEngine() {
    var loader = new Image();
    loader.crossOrigin = 'anonymous';
    loader.onload = function () {
      var w = loader.naturalWidth, h = loader.naturalHeight;
      var c = document.createElement('canvas');
      c.width = w; c.height = h;
      var ctx = c.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(loader, 0, 0);
      var data;
      try {
        data = ctx.getImageData(0, 0, w, h).data;
      } catch (e) {
        return;
      }
      var n = w * h;
      var vArr = new Float32Array(n);
      var deckCandidate = new Uint8Array(n);
      var darkMask = new Uint8Array(n);
      var brightMask = new Uint8Array(n);
      for (var i = 0; i < n; i++) {
        var o = i * 4, a = data[o + 3];
        if (a < 10) continue;
        var hsv = rgbToHsv(data[o] / 255, data[o + 1] / 255, data[o + 2] / 255);
        vArr[i] = hsv[2];
        if (hsv[1] >= 0.15) deckCandidate[i] = 1;
        else if (hsv[2] < 0.18) darkMask[i] = 1;
        else brightMask[i] = 1;
      }

      deckCandidate = majorityFilter(deckCandidate, w, h, 5);

      var deckCC = labelComponents(deckCandidate, w, h);
      var majorThresh = Math.max(60, Math.round(w * h * 0.002));
      var isMajorComp = new Uint8Array(deckCC.count);
      for (var dci = 0; dci < deckCC.count; dci++) {
        if (deckCC.sizes[dci] >= majorThresh) isMajorComp[dci] = 1;
      }
      var majorMask = new Uint8Array(n);
      for (var dpi = 0; dpi < n; dpi++) {
        if (deckCandidate[dpi] && isMajorComp[deckCC.labels[dpi]]) majorMask[dpi] = 1;
      }
      var mergeRadius = Math.max(4, Math.round(h * 0.065));
      var distToMajor = chebyshevDistanceTo(majorMask, w, h);
      var minDistPerComp = new Array(deckCC.count).fill(Infinity);
      for (var dpi2 = 0; dpi2 < n; dpi2++) {
        if (!deckCandidate[dpi2]) continue;
        var lblId = deckCC.labels[dpi2];
        if (isMajorComp[lblId]) continue;
        if (distToMajor[dpi2] < minDistPerComp[lblId]) minDistPerComp[lblId] = distToMajor[dpi2];
      }
      for (var dpi3 = 0; dpi3 < n; dpi3++) {
        if (!deckCandidate[dpi3]) continue;
        var lblId2 = deckCC.labels[dpi3];
        if (!isMajorComp[lblId2] && minDistPerComp[lblId2] > mergeRadius) deckCandidate[dpi3] = 0;
      }

      var darkCC = labelComponents(darkMask, w, h);
      var seatwell = new Uint8Array(n);
      if (darkCC.count > 0) {
        var biggest = 0, biggestSize = -1;
        for (var ci = 0; ci < darkCC.count; ci++) {
          if (darkCC.sizes[ci] > biggestSize) { biggestSize = darkCC.sizes[ci]; biggest = ci; }
        }
        for (var pi = 0; pi < n; pi++) if (darkCC.labels[pi] === biggest) seatwell[pi] = 1;
      }
      var seatwellDilated = dilate(seatwell, w, h, 6);

      var brightCC = labelComponents(brightMask, w, h);
      var touchesSeatwell = new Uint8Array(brightCC.count);
      for (var bi = 0; bi < n; bi++) {
        if (brightMask[bi] && seatwellDilated[bi]) touchesSeatwell[brightCC.labels[bi]] = 1;
      }
      var ringMask = new Uint8Array(n);
      for (var bj = 0; bj < n; bj++) {
        if (brightMask[bj] && touchesSeatwell[brightCC.labels[bj]]) ringMask[bj] = 1;
      }

      var ringWall = dilate(ringMask, w, h, 2);
      var reached = floodFillOutside(ringWall, w, h);

      var label = new Uint8Array(n);
      var deckVs = [], cockpitVs = [];
      for (var k = 0; k < n; k++) {
        if (ringMask[k]) { label[k] = 2; cockpitVs.push(vArr[k]); continue; }
        if (!reached[k]) { label[k] = 0; continue; }
        if (deckCandidate[k]) { label[k] = 1; deckVs.push(vArr[k]); continue; }
        label[k] = 0;
      }

      var deckMaskF = new Uint8Array(n), cockpitMaskF = new Uint8Array(n), keepMaskF = new Uint8Array(n);
      for (var fk = 0; fk < n; fk++) {
        if (label[fk] === 1) deckMaskF[fk] = 1;
        else if (label[fk] === 2) cockpitMaskF[fk] = 1;
        else keepMaskF[fk] = 1;
      }
      var wDeck = featherWeights(deckMaskF, w, h);
      var wCockpit = featherWeights(cockpitMaskF, w, h);
      var wKeep = featherWeights(keepMaskF, w, h);
      for (var wk = 0; wk < n; wk++) {
        var tot = wDeck[wk] + wCockpit[wk] + wKeep[wk];
        if (tot < 1e-6) { wKeep[wk] = 1; continue; }
        wDeck[wk] /= tot; wCockpit[wk] /= tot; wKeep[wk] /= tot;
      }

      engine = {
        w: w, h: h, label: label, v_: vArr,
        wDeck: wDeck, wCockpit: wCockpit, wKeep: wKeep,
        deckRefV: median(deckVs), cockpitRefV: median(cockpitVs),
        canvas: document.createElement('canvas'), srcData: data
      };
      engine.canvas.width = w; engine.canvas.height = h;
      engine.ctx = engine.canvas.getContext('2d');
      engineReadyCbs.forEach(function (cb) { cb(); });
      engineReadyCbs = [];
    };
    loader.src = BOAT_URL;
  }

  function whenEngineReady(cb) {
    if (engine) cb(); else engineReadyCbs.push(cb);
  }

  function recolourDataUrl(deckHex, cockpitHex) {
    if (!engine) return null;
    var w = engine.w, h = engine.h, n = w * h;
    var src = engine.srcData;
    var out = engine.ctx.createImageData(w, h);
    var od = out.data;
    var deckRgb = hexToRgb01(deckHex), cockpitRgb = hexToRgb01(cockpitHex);
    var deckHsv = rgbToHsv(deckRgb[0], deckRgb[1], deckRgb[2]);
    var cockpitHsv = rgbToHsv(cockpitRgb[0], cockpitRgb[1], cockpitRgb[2]);
    for (var i = 0; i < n; i++) {
      var o = i * 4;
      var a = src[o + 3];
      od[o + 3] = a;
      if (a < 10) continue;
      var wD = engine.wDeck[i], wC = engine.wCockpit[i], wK = engine.wKeep[i];
      if (wD < 0.004 && wC < 0.004) {
        od[o] = src[o]; od[o + 1] = src[o + 1]; od[o + 2] = src[o + 2];
        continue;
      }
      var v = engine.v_[i];
      var deckNv = Math.min(1, Math.max(0, deckHsv[2] + (v - engine.deckRefV)));
      var deckPaint = hsvToRgb(deckHsv[0], deckHsv[1], deckNv);
      var cockpitNv = Math.min(1, Math.max(0, cockpitHsv[2] + (v - engine.cockpitRefV)));
      var cockpitPaint = hsvToRgb(cockpitHsv[0], cockpitHsv[1], cockpitNv);
      var rr = deckPaint[0] * wD + cockpitPaint[0] * wC + (src[o] / 255) * wK;
      var gg = deckPaint[1] * wD + cockpitPaint[1] * wC + (src[o + 1] / 255) * wK;
      var bb = deckPaint[2] * wD + cockpitPaint[2] * wC + (src[o + 2] / 255) * wK;
      od[o] = Math.round(rr * 255);
      od[o + 1] = Math.round(gg * 255);
      od[o + 2] = Math.round(bb * 255);
    }
    engine.ctx.putImageData(out, 0, 0);
    return engine.canvas.toDataURL('image/png');
  }

  var BOAT_URL = null;
  var state = { deck: DEFAULT_DECK, cockpit: DEFAULT_COCKPIT, url: null };

  document.addEventListener('rc-colour', function (e) {
    var d = e.detail || {};
    if (d.src === 'pk') return;
    state.deck = d.deck || DEFAULT_DECK;
    state.cockpit = d.cockpit || DEFAULT_COCKPIT;
    var sa = document.getElementById('rc-sc-deck'), sb = document.getElementById('rc-sc-cockpit');
    if (sa) sa.value = state.deck;
    if (sb) sb.value = state.cockpit;
    refresh();
  });

  function hexFor(name) {
    for (var i = 0; i < PALETTE.length; i++) if (PALETTE[i][0] === name) return PALETTE[i][1];
    return '#fcfcfc';
  }

  function refresh() {
    whenEngineReady(function () {
      var url = recolourDataUrl(hexFor(state.deck), hexFor(state.cockpit));
      if (!url) return;
      state.url = url;
      applyToImages();
    });
  }

  function findTargetImages() {
    var fresh = document.querySelectorAll('img[src*="' + BASE_MATCH + '"], img[srcset*="' + BASE_MATCH + '"]');
    for (var i = 0; i < fresh.length; i++) fresh[i].setAttribute('data-rc-salt-colour', '1');
    return document.querySelectorAll('img[data-rc-salt-colour]');
  }

  function applyToImages() {
    if (!state.url) return;
    var imgs = findTargetImages();
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i];
      if (im.hasAttribute('srcset')) im.removeAttribute('srcset');
      if (im.hasAttribute('sizes')) im.removeAttribute('sizes');
      if (im.src !== state.url) im.src = state.url;
    }
  }

  var hiddenDeck, hiddenCockpit;
  function ensureFormInputs() {
    if (document.querySelector('#rc-cfg input[name="properties[Deck Colour]"]')) {
      [hiddenDeck, hiddenCockpit].forEach(function (x) { if (x && x.parentNode) x.parentNode.removeChild(x); });
      hiddenDeck = hiddenCockpit = null;
      return;
    }
    var form = document.querySelector('form[id*="BuyButtons-ProductForm"], form[action*="/cart/add"]');
    if (!form) return;
    if (!hiddenDeck || !form.contains(hiddenDeck)) {
      hiddenDeck = form.querySelector('input[name="properties[Deck Colour]"]') || document.createElement('input');
      hiddenDeck.type = 'hidden';
      hiddenDeck.name = 'properties[Deck Colour]';
      if (!form.contains(hiddenDeck)) form.appendChild(hiddenDeck);
    }
    if (!hiddenCockpit || !form.contains(hiddenCockpit)) {
      hiddenCockpit = form.querySelector('input[name="properties[Cockpit Colour]"]') || document.createElement('input');
      hiddenCockpit.type = 'hidden';
      hiddenCockpit.name = 'properties[Cockpit Colour]';
      if (!form.contains(hiddenCockpit)) form.appendChild(hiddenCockpit);
    }
    hiddenDeck.value = state.deck;
    hiddenCockpit.value = state.cockpit;
  }

  var style = document.createElement('style');
  style.textContent =
    '.rc-sc{position:absolute;top:.75rem;left:.75rem;z-index:2;display:flex;flex-direction:column;gap:.5rem}' +
    '.rc-sc__f{display:flex;flex-direction:column;gap:.3rem}' +
    '.rc-sc label{color:rgba(255,255,255,.75);font:700 .72rem/1 Arial,sans-serif;text-transform:uppercase;letter-spacing:.04em}' +
    ".rc-sc select{appearance:none;-webkit-appearance:none;-moz-appearance:none;min-width:11rem;padding:.6rem 2.2rem .6rem .9rem;border-radius:999px;border:1px solid rgba(255,255,255,.45);background-color:rgba(20,20,20,.9);background-image:url('data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 10 6%22%3E%3Cpath d=%22M1 1l4 4 4-4%22 fill=%22none%22 stroke=%22white%22 stroke-width=%221.6%22/%3E%3C/svg%3E');background-repeat:no-repeat;background-position:right .9rem center;background-size:10px 6px;color:#fff;font:600 .95rem/1 Arial,sans-serif;cursor:pointer}" +
    '.rc-sc select:focus-visible{outline:2px solid #fff;outline-offset:2px}' +
    '@media(max-width:480px){.rc-sc{top:.6rem;left:.6rem}.rc-sc select{min-width:9rem;font-size:.85rem}}';
  document.head.appendChild(style);

  function buildSelect(id, labelText, which) {
    var f = document.createElement('div');
    f.className = 'rc-sc__f';
    var lab = document.createElement('label');
    lab.setAttribute('for', id);
    lab.textContent = labelText;
    var sel = document.createElement('select');
    sel.id = id;
    PALETTE.forEach(function (c) {
      var opt = document.createElement('option');
      opt.value = c[0];
      opt.textContent = c[0];
      try { opt.style.backgroundColor = c[1]; } catch (e) {}
      sel.appendChild(opt);
    });
    sel.value = which === 'deck' ? state.deck : state.cockpit;
    sel.addEventListener('change', function () {
      if (which === 'deck') state.deck = sel.value; else state.cockpit = sel.value;
      document.dispatchEvent(new CustomEvent('rc-colour', { detail: { deck: state.deck, cockpit: state.cockpit, src: 'pk' } }));
      ensureFormInputs();
      refresh();
    });
    f.appendChild(lab);
    f.appendChild(sel);
    return { wrap: f, select: sel };
  }

  function injectDropdowns(lb) {
    if (lb.querySelector('.rc-sc')) return;
    var wrap = document.createElement('div');
    wrap.className = 'rc-sc';
    var deckCtl = buildSelect('rc-sc-deck', labelPair[0], 'deck');
    var cockpitCtl = buildSelect('rc-sc-cockpit', labelPair[1], 'cockpit');
    wrap.appendChild(deckCtl.wrap);
    wrap.appendChild(cockpitCtl.wrap);
    lb.appendChild(wrap);
  }

  function scanLightbox() {
    var lb = document.querySelector('.rc-lb');
    if (lb && !lb.hidden) injectDropdowns(lb);
    applyToImages();
  }

  new MutationObserver(scanLightbox).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['hidden'],
    subtree: true,
    childList: true
  });
  scanLightbox();

  function containsMatchingImage(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.tagName === 'IMG') return !!((node.src && node.src.indexOf(BASE_MATCH) !== -1) || (node.srcset && node.srcset.indexOf(BASE_MATCH) !== -1));
    return !!(node.querySelector && node.querySelector('img[src*="' + BASE_MATCH + '"], img[srcset*="' + BASE_MATCH + '"]'));
  }
  new MutationObserver(function (muts) {
    var touched = false;
    for (var i = 0; i < muts.length && !touched; i++) {
      var m = muts[i];
      if (m.type === 'attributes') {
        var t = m.target;
        if (t && t.tagName === 'IMG' && (t.hasAttribute('data-rc-salt-colour') || (t.src && t.src.indexOf(BASE_MATCH) !== -1)) && (t.src !== state.url || t.hasAttribute('srcset'))) touched = true;
      } else if (m.addedNodes) {
        for (var j = 0; j < m.addedNodes.length; j++) {
          if (containsMatchingImage(m.addedNodes[j])) { touched = true; break; }
        }
      }
    }
    if (touched) applyToImages();
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['src', 'srcset'], childList: true, subtree: true });

  function relabelPill() {
    var span = document.querySelector('.rc-zh7 span');
    if (span && span.textContent !== pillText) span.textContent = pillText;
  }
  new MutationObserver(relabelPill).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
  relabelPill();
  var n = 0;
  var t = setInterval(function () {
    relabelPill();
    applyToImages();
    ensureFormInputs();
    if (++n === 60) {
      clearInterval(t);
      t = setInterval(function () {
        relabelPill();
        applyToImages();
        ensureFormInputs();
      }, 2000);
    }
  }, 300);

  var boatImg = document.querySelector('.rc-boat img, img[src*="' + BASE_MATCH + '"]');
  BOAT_URL = boatImg ? (boatImg.currentSrc || boatImg.src).replace(/([?&])width=\d+/, '$1width=3000') : null;
  if (!BOAT_URL) {
    var poll = setInterval(function () {
      var im = document.querySelector('img[src*="' + BASE_MATCH + '"]');
      if (im) {
        clearInterval(poll);
        BOAT_URL = (im.currentSrc || im.src).replace(/([?&])width=\d+/, '$1width=3000');
        buildEngine();
        refresh();
        ensureFormInputs();
      }
    }, 200);
  } else {
    buildEngine();
    refresh();
  }
  document.addEventListener('DOMContentLoaded', ensureFormInputs);
  window.addEventListener('load', function () { ensureFormInputs(); applyToImages(); });
})();
